import ChatAuthenticationModal from './chatAuthenticationModal';

export default ChatAuthenticationModal;
